export const TITLE = 'Admin'
export const PATH = '/admin'
export const CLASS_NAME = 'cst-page-admin'
